import React from 'react';
import './Result.style.css';
import { Result as ResultANTD } from 'antd';

const Result = (props) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  const {
    status = 'success',
    icon,
    title = '성공',
    subTitle,
    extra,
    children,
    layoutStyle = {},
  } = props;
  /* ===== State ===== */
  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /* ===== Render ===== */
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 500,
        ...layoutStyle,
      }}
    >
      <ResultANTD
        status={status}
        icon={icon}
        title={title}
        subTitle={subTitle}
        extra={extra}
      >
        {children}
      </ResultANTD>
    </div>
  );
};

export default Result;
